import { useApiWithAuth } from '@/hooks/api';
import { useUsersStore } from '@/store/users';
import { loadUsers } from '@/store/users/actions';
import type { UserStatus } from '@/store/users/types';
import { useEffect, useMemo } from 'react';

export function useUserStatusList(status: UserStatus) {
  const store = useUsersStore();

  return useMemo(() => {
    return store.computed.usersList.filter(
      (item) =>
        (item.data.active && !item.data.archived && status === 'active') ||
        (!item.data.active && !item.data.archived && status === 'inactive') ||
        (item.data.archived && status === 'archived'),
    );
  }, [status, store.computed.usersList]);
}

export function useUsersLookup(/*status?: UserStatus*/) {
  const store = useUsersStore();
  const { api, auth } = useApiWithAuth();
  useEffect(() => {
    loadUsers(store, { force: false, api, auth });
  }, [api, auth, store]);

  return store.state.users || {};
}
